/**
 * Mapeo de códigos de paquetes
 */
export const packageCode = {
  TARJETA_SUELTA: "00",
  LIBRETON_EXPRESS: "09",
  LIBRETON_FULL: "07",
  LIBRETON_PLUS_GOLD: "01",
  LIBRETON_PREMIUM: "08",
  LIBRETON_PREMIUM_WORLD: "04"
};

/**
 * Mapeo de nombres de paquetes
 * (usado para píxeles)
 */
export const nombresPaquetes = paquete => {
  switch (paquete) {
    case packageCode.LIBRETON_EXPRESS:
      return "Paquete Express";
    case packageCode.LIBRETON_PLUS_GOLD:
      return "Paquete Gold";
    case packageCode.LIBRETON_FULL:
      return "Paquete Full";
    case packageCode.LIBRETON_PREMIUM:
      return "Paquete Platinum";
    case packageCode.LIBRETON_PREMIUM_WORLD:
      return "Paquete Black";
    default:
      return "";
  }
};

/**
 * Mapeo de códigos de tarjetas
 */
export const codigosTarjetas = {
  VISA_INTERNACIONAL: "CI",
  VISA_GOLD: "PP",
  VISA_PLATINUM: "LL",
  VISA_SIGNATURE: "SS",
  MASTERCARD_INTERNACIONAL: "12",
  MASTERCARD_GOLD: "13",
  MASTERCARD_PLATINUM: "18",
  MASTERCARD_BLACK: "43"
};

/**
 * Mapeo de nombres de tarjetas
 */
export const nombresTarjetas = {
  VISA_INTERNACIONAL: "Visa Internacional",
  VISA_GOLD: "Visa Gold",
  VISA_PLATINUM: "Visa Platinum",
  VISA_SIGNATURE: "Visa Signature",
  MASTERCARD_INTERNACIONAL: "Mastercard Internacional",
  MASTERCARD_GOLD: "Mastercard Gold",
  MASTERCARD_PLATINUM: "Mastercard Platinum",
  MASTERCARD_BLACK: "Mastercard Black"
};

export const nombresTarjetasPorCodigo = codigo => {
  const codigos = {};
  Object.keys(codigosTarjetas).forEach(key => {
    codigos[codigosTarjetas[key]] = key;
  });

  return nombresTarjetas[codigos[codigo]];
};
